import { useNavigate, useOutletContext } from 'react-router'
import { FaUser } from 'react-icons/fa'

import { useUpdateUserFollowsMutation } from '../../services/apiSlice'
import { CurrentUser } from '../../services/schema/User'
import { UserFollow } from '../../services/schema/User'

interface Props {
  user: UserFollow
}

const UserCard: React.FC<Props> = ({ user }) => {
  const navigate = useNavigate()
  const { username: currUser, userFollowsCount } =
    useOutletContext<CurrentUser>()
  const [updateUserFollows, { isSuccess, isError, isLoading }] =
    useUpdateUserFollowsMutation()

  const profilePic =
    user.profilePicture !== null ? user.profilePicture : '/user_sample.jpg'

  const followedByCurrUser =
    currUser !== user.username &&
    Array.isArray(userFollowsCount.following) &&
    userFollowsCount.following.includes(user.username)

  return (
    <div className="border-theme hover-sub relative flex h-auto w-full max-w-[600px] p-[25px]">
      <div className="flex h-auto w-[50px] shrink-0 select-none">
        <div
          data-id="profile-picture"
          className="flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-full bg-cover bg-center"
          style={{
            backgroundImage: `url(${profilePic})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
      </div>
      <div className="flex w-full flex-col">
        <div className="flex justify-between">
          <div className="flex flex-col">
            <div className="flex items-center">
              <button
                type="button"
                data-typeid="post-profile-btn"
                onClick={() => {
                  navigate(`/${user.username}`, { replace: true })
                }}
                className="flex cursor-pointer items-center"
              >
                <div className="hover:underline hover:underline-offset-2">
                  <p>{user.displayName}</p>
                </div>
                <span className="text-blue pl-[5px]">
                  <FaUser />
                </span>
              </button>
            </div>
            <div className="flex items-center">
              <button
                type="button"
                data-typeid="post-profile-btn"
                onClick={() => {
                  navigate(`/${user.username}`, { replace: true })
                }}
                className="text-sub cursor-pointer"
              >
                <div>
                  <p>@{user.username}</p>
                </div>
              </button>
            </div>
          </div>
          <div className="flex h-full items-center">
            {currUser !== user.username && (
              <button
                type="button"
                className="border-theme hover-main flex h-auto w-auto cursor-pointer rounded-full border px-[20px] py-[5px] font-bold"
                onClick={() => {
                  if (followedByCurrUser) {
                    if (confirm('Are you sure you want to unfollow?')) {
                      updateUserFollows({
                        type: 'unfollow',
                        currUser: currUser,
                        otherUser: user.username as string,
                      })
                      return
                    }
                  }
                  updateUserFollows({
                    type: 'follow',
                    currUser: currUser,
                    otherUser: user.username as string,
                  })
                }}
              >
                {followedByCurrUser ? 'Unfollow' : 'Follow'}
              </button>
            )}
          </div>
        </div>
        <div className="block h-auto w-full">
          <span className="overflow-wrap flex break-words break-all whitespace-pre-wrap">
            {user.bioText}
          </span>
        </div>
      </div>
    </div>
  )
}

export default UserCard
